import { StrictMode } from "react"

import "@fontsource-variable/inter"
import { createRoot } from "react-dom/client"

import "@/shared/i18n"

import App from "./app"
import "./index.css"

// Polyfills for Menu component (popover + anchor positioning)
if (!("popover" in HTMLElement.prototype)) {
  void import("@oddbird/popover-polyfill")
}

if (!("anchorName" in document.documentElement.style)) {
  void import("@oddbird/css-anchor-positioning")
}

const rootElement = document.getElementById("root")
if (!rootElement) throw new Error("[main] Missing #root mount node")

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
)
